import { WorldPayCustomisation as IWorldPayCustomisation } from "@interfaces/PaymentProviders/WorldPayConfig.interface";

export const WorldPayCustomisation: IWorldPayCustomisation = {
  buttons: {
    backgroundColor: '#f9b000',
    color: '#292929',
    border: {
      style: 'none',
      radius: '0px'
    },
  },
  inputs: {
    backgroundColor: '#ffffff',
    border: {
      style: 'solid',
      width: '1px',
      radius: '0px',
      color: '#a9a9a9',
    },
    validation: {
      ok: {
        color: '#8fe85f',
      },
      error: {
        color: '#ff5349',
      },
    },
    placeholder: {
      color: '#adb5bd',
    },
  },
  page: {
    backgroundColor: '#ffffff',
    color: '#292929',
  },
};